import { EDUCATIONAL_ADVISOR } from "./education-advisors";

export enum BATCH_ORGANIZER_TYPE {
  PROVIDER = EDUCATIONAL_ADVISOR.PROVIDER,
  TEACHER = EDUCATIONAL_ADVISOR.TEACHER,
}
